import useEthicsForm from './useEthicsForm'
//View
export type EthicsFormView = ReturnType<typeof useEthicsForm> & {
    disabled?: boolean
    isDisableRIB?: boolean
    isDisablePhase?: boolean
    isDisableNumPhase?: boolean
    isShowNeedEditForm?: boolean
} & EthicsFormType

//Controller
export type EthicsFormType = {
    disabled?: boolean
    callbackChangeFaculty?: (irb?: string) => void
    isNotCompleteDocument?: boolean
    isDisableRIB?: boolean
    isDisablePhase?: boolean
    isDisableNumPhase?: boolean
    callbackChangeResearcherType?: (val: string) => void
    isShowNeedEditForm?: boolean
    isNeedEditForm?: boolean
    isDisableNeedEditForm?: boolean
    isEditAfterReview?: boolean
    headerLabel?: string
    hideAccordion?: boolean
}

//Model
export type UseEthicsFormType = Omit<EthicsFormType, ''>

export type OptType = {
    label: string
    value: string
}
export type RadType = {
    id: string
    name: string
}

export enum ResearcherType {
    student = '1', // นิสิต/นักศึกษา
    teacher = '2', // นักวิจัย/อาจารย์
}
